import { useEffect, useState } from 'react';
import { Row } from './Row';
import { TotalRow } from './TotalRow';

export function RowsContainer({ items, mktValue }) {
  const [totals, setTotals] = useState({
    totalMktPerVendedor: 0,
    totalMktPerChamado: 0,
    totalMktPerPedido: 0
  });
  const totalChamadosNovosVendedor = items?.data?.reduce(
    (acc, item) => acc + item.quantidade_novos,
    0
  );

  useEffect(() => {
    const totalMktPerVendedor = items?.data?.reduce(
      (acc, item) => acc + (mktValue / totalChamadosNovosVendedor || 0) * item.quantidade_novos,
      0
    );
    const totalMktPerChamado = items?.data?.reduce(
      (acc, item) =>
        acc + ((mktValue / item.quantidade_vendedor || 0) / item.quantidade_novos || 0),
      0
    );
    const totalMktPerPedido = items?.data?.reduce(
      (acc, item) =>
        acc +
        (item.quantidade_novos > 0
          ? (mktValue / totalChamadosNovosVendedor || 0) * item.quantidade_novos
          : 0),
      0
    );

    setTotals({ totalMktPerVendedor, totalMktPerChamado, totalMktPerPedido });
  }, [items?.data, mktValue, totalChamadosNovosVendedor]);

  return (
    <>
      {items?.data?.map((item) => (
        <Row
          key={item.total_pedidos + item.valor_total_pedidos}
          item={item}
          mktValue={mktValue}
          totalChamadosNovosVendedor={totalChamadosNovosVendedor}
        />
      ))}
      <TotalRow {...totals} items={items} />
    </>
  );
}
